(function ($) {
  var $youcamElement = $('#YMK-module');
  var youcamAPIKey = Drupal.settings.vto.api_key;
  var youcamAPIUrl = Drupal.settings.vto.api_url;
  var youcamEvents = [
    'cameraClosed',
    'cameraFailed',
    'cameraOpened',
    'compare',
    'compareDisabled',
    'closed',
    'engineClosed',
    'loaded',
    'loading',
    'kissDetected',
    'opened',
    'photoLoaded',
    'photoSaved',
    'reset',
    'videoLoaded',
    'shadeFinderStarted',
    'shadeFinderComplete',
    'shadeFinderCancelled',
    'zoom'
  ];

  function trackEvent(eventName, eventLabel, eventValue) {
    if (site && site.track) {
      site.track.evtLink({
        event_name: 'vto',
        event_category: 'vto',
        event_action: eventName,
        modiface_evar: `YouCam | ${eventName} | event`,
        page_name: `YouCam | ${eventName} | event`,
        ...(eventLabel && { event_label: eventLabel }),
        ...(eventValue && { event_value: eventValue }),
        vendor: 'youcam',
        vto_type: 'Looks'
      });
    }
  }

  function initYouCam(skipEventListener) {
    var widthToLoad = $youcamElement.parent().width() > 600 ? 600 : $youcamElement.parent().width();
    var heightToLoad =
      $(window).width() < $(window).height() ? $(window).height() * 0.55 : widthToLoad * (4 / 3);
    var disableFBSharing = Drupal?.settings?.globals_variables?.disable_fb_sharing;
    var disableTwitterSharing = Drupal?.settings?.globals_variables?.disable_twitter_sharing;
    var disablePinterestSharing = Drupal?.settings?.globals_variables?.disable_pinterest_sharing;
    var vtoParams = {
      autoOpen: true,
      showCloseBtnOnLauncher: false,
      width: widthToLoad,
      height: heightToLoad,
      ...(disableFBSharing && { enableFBSharing: !disableFBSharing}),
      ...(disableTwitterSharing && { enableTwitterSharing: !disableTwitterSharing}),
      ...(disablePinterestSharing && { enablePinterestSharing: !disablePinterestSharing}),
      language: Drupal.settings.vto.language ? Drupal.settings.vto.language : null
    };
    var eventCameraStart, eventCameraEnd;

    window.YMK.init(vtoParams);
    $(document).trigger('VTOLooksLandingPage.youcamLoadedAtHeight', [heightToLoad]);
    if (skipEventListener) {
      return false;
    }
    $(document).on('applyLooks', function (event, target) {
      var eventLabel = `${$(target).data('vto')} | ${$(target)
        .find('.js-vto-looks-landing-page-single-look-title > a')
        .text()}`;
      trackEvent('applyLooks', eventLabel);
    });

    youcamEvents.forEach(function (youcamEvent) {
      var eventValue;
      window.YMK.addEventListener(youcamEvent, function (progress) {
        var eventName = youcamEvent;

        switch (youcamEvent) {
          case 'closed': {
            initYouCam(true);
            break;
          }
          case 'cameraOpened': {
            eventCameraStart = performance.now();
            break;
          }
          case 'loaded': {
            eventCameraEnd = performance.now();
            eventValue = Math.floor(eventCameraEnd - eventCameraStart);
            $(document).trigger('VTOLooksLandingPage.youcamLoadedAtHeight', [heightToLoad]);
            break;
          }
          case 'loading': {
            if (progress === 10) {
              eventName = 'loading-start';
            } else if (progress === 100) {
              eventName = 'loading-complete';
            }
            break;
          }
        }

        if (eventName !== 'loading') {
          trackEvent(eventName, undefined, eventValue);
        }
      });
    });
  }

  (function (d, k) {
    var s = d.createElement('script');

    s.type = 'text/javascript';
    s.async = true;
    s.src = youcamAPIUrl + k;
    var x = d.getElementsByTagName('script')[0];

    x.parentNode.insertBefore(s, x);
  })(document, youcamAPIKey);

  window.ymkAsyncInit = function () {
    initYouCam();
  };
})(jQuery);
